import axios from 'axios'

export default (baseUrl) => {

  const cuisinesUrl = `${baseUrl}/venues/options/cuisines.description`
  const ambiencesUrl = `${baseUrl}/ordered_ambiences`

  const cuisines = axios.get(cuisinesUrl)
  const ambiences = axios.get(ambiencesUrl)

  return Promise.all([cuisines, ambiences])

}